import React from 'react';
import { ContentTypeLogo } from 'src/dashboard/ContentTypeLogo';

import { getContentMetadata } from 'src/utils/journey';
import { isValidUrl } from 'src/utils/url';
import { Content } from 'src/common/interfaces/content.interface';
import { Node } from 'src/common/interfaces/node.interface';
import contentEditable from 'src/utils/contentEditable';
import { apiUpdateContent } from 'src/utils/journeyApi';
import classNames from 'classnames';

interface LibraryContentCardSmallProps {
  content: Content | Node;
  onClick?: (content: any) => void;
  editable?: boolean;
  metadataClassName?: string;
  titleContainerClassName?: string;
  onUpdateContent?: (content: Content) => void;
}

export const LibraryContentSmallCard = ({
  content,
  editable = false,
  metadataClassName = '',
  titleContainerClassName = '',
  onUpdateContent,
}: LibraryContentCardSmallProps) => {
  const contentMetadata = getContentMetadata(content);
  const isMetaURL = Boolean(isValidUrl(contentMetadata));
  const EditableContentName = contentEditable('span');

  const onContentNameUpdate = (name: string) => {
    return apiUpdateContent(content.id, { name }).then((content: Content) => {
      onUpdateContent && onUpdateContent(content);
    });
  };

  const nameClasses = 'text-bedrock-p text-bedrock-black line-clamp-2 lg:line-clamp-none';

  return (
    <div className='relative flex justify-start items-start rounded-lg'>
      <ContentTypeLogo
        destination={content?.embed?.destination}
        externalLinkUrl={content?.external_link?.url}
        contentType={content.content_type}
      />
      <div className={classNames('flex flex-col ml-2 min-w-0 flex-grow-0', titleContainerClassName)}>
        {editable ? (
          <EditableContentName
            className={nameClasses}
            data-placeholder={'Name this content'}
            value={content.name || 'Name this content'}
            disableAutoFocus={true}
            onSave={(prevValue, newValue) => onContentNameUpdate(newValue)}
            style={{ wordBreak: 'break-word' }}
          />
        ) : (
          <span className={nameClasses}>{content.name}</span>
        )}
        {isMetaURL ? (
          <a
            className={classNames(
              'text-bedrock-p has-hover text-bedrock-dark-gray break-all line-clamp-1 hover:underline',
              metadataClassName
            )}
            href={contentMetadata}
            target='_blank'
            rel='noopener noreferrer'
          >
            {contentMetadata}
          </a>
        ) : (
          <div className={classNames('text-bedrock-p-small text-bedrock-dark-gray truncate', metadataClassName)}>
            {contentMetadata}
          </div>
        )}
      </div>
    </div>
  );
};
